import React from 'react';
import { SvgIcon } from '@material-ui/core';

export default function HeartIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 25 21">
      <path fillRule="evenodd" clipRule="evenodd" d="M10.798 1.85264C8.32778 -0.617546 4.32282 -0.617546 1.85264 1.85264C-0.617546 4.32282 -0.617546 8.32778 1.85264 10.798L11.5009 20.4462C11.7111 20.6564 11.9916 20.7535 12.2667 20.7374C12.5418 20.7535 12.8222 20.6564 13.0324 20.4462L22.6807 10.798C25.1509 8.32778 25.1509 4.32282 22.6807 1.85264C20.2105 -0.617546 16.2056 -0.617546 13.7354 1.85264L12.2667 3.32135L10.798 1.85264Z" fill="#292929"/>
    </SvgIcon>
  );
}